<span [ngClass]="iconClass" class="icon icon-info" (mouseover)="showDescription()" (mouseout)="hideDescription()"></span>
<div *ngIf="show" class="description" [ngClass]="divClassList" [innerHTML]="description"></div>
<input type="hidden" [value]="description" />
